
import { chipsConfig, ChipsCategories } from './configs/chips.config';

export interface ComponentsStoreState {
  searchedGame?: string;
  homeCategortiesOrGamesView?: boolean; // false = categories, true = games view is shown
  chipsCategories: ChipsCategories
}

export const InitialStoreState: ComponentsStoreState = {
  searchedGame: '',
  homeCategortiesOrGamesView: false,
  chipsCategories: chipsConfig
}
